import { data } from 'react-router'
import { AlianzasSection } from '#app/components/alianzas-section.tsx'
import {
	ContactoAliadosSchema,
	sendContactoAliadosEmail,
} from '#app/utils/email.server.ts'
import { type Route } from './+types/about.ts'

// Action para manejar el envío del formulario
export async function action({ request }: Route.ActionArgs) {
	const formData = await request.formData()

	const formDataObject = Object.fromEntries(formData)

	// Validar datos con Zod schema
	const validation = ContactoAliadosSchema.safeParse(formDataObject)

	if (!validation.success) {
		const errors: Record<string, string[]> = {}

		validation.error.errors.forEach((error) => {
			const field = error.path[0] as string
			if (!errors[field]) {
				errors[field] = []
			}
			errors[field].push(error.message)
		})

		return data({ success: false, errors })
	}

	try {
		// Enviar email usando el servicio
		await sendContactoAliadosEmail(validation.data)

		return data({
			success: true,
			message:
				'¡Gracias por tu interés! Hemos recibido tu información y te contactaremos pronto para explorar oportunidades de colaboración.',
		})
	} catch (error) {
		console.error('Error enviando formulario de aliados:', error)
		return data({
			success: false,
			message:
				'Ocurrió un error al enviar el formulario. Por favor intenta nuevamente o contactanos directamente.',
		})
	}
}

export default function AboutRoute() {
	return (
		<div className="min-h-screen bg-gradient-to-br from-blue-600 to-green-500">
			<AlianzasSection />
		</div>
	)
}
